<template>
  <b-sidebar
    id="add-new-store-sidebar"
    :visible="isAddNewStoreSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-store-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        "
      >
        <h5 class="mb-0">{{ button_text }} Store</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <!-- Name-->
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group class="required" label="Name" label-for="name">
                <b-form-input
                  id="name"
                  v-model="storeData.name"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Store Name"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Address -->
            <validation-provider
              #default="validationContext"
              name="Address"
              rules="required"
            >
              <b-form-group
                class="required"
                label="Address"
                label-for="address"
              >
                <b-form-input
                  id="address"
                  v-model="storeData.address"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Address"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Phone -->
            <validation-provider
              #default="validationContext"
              name="Phone"
              rules="required"
            >
              <b-form-group class="required" label="Phone" label-for="phone">
                <b-form-input
                  id="phone"
                  v-model="storeData.phone"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Phone"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Email -->
            <validation-provider
              #default="validationContext"
              name="Email"
              rules="required"
            >
              <b-form-group class="required" label="Email" label-for="email">
                <b-form-input
                  id="email"
                  v-model="storeData.email"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Email"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Website -->
            <b-form-group class="required" label="Website" label-for="website">
              <b-form-input
                id="website"
                v-model="storeData.website"
                autofocus
                trim
                placeholder="Website"
              />
            </b-form-group>
            <!-- Working Hour -->
            <b-form-group class="required" label="Working Hour" label-for="working_hour">
              <b-form-input
                id="working_hour"
                v-model="storeData.working_hour"
                autofocus
                trim
                placeholder="Working Hour"
              />
            </b-form-group>
            <!-- Facebook -->
            <b-form-group
              class="required"
              label="Facebook"
              label-for="facebook_link"
            >
              <b-form-input
                id="facebook_link"
                v-model="storeData.facebook_link"
                autofocus
                trim
                placeholder="Facebook"
              />
            </b-form-group>
            <!-- Instagram -->
            <b-form-group
              class="required"
              label="Instagram"
              label-for="ig_link"
            >
              <b-form-input
                id="ig_link"
                v-model="storeData.ig_link"
                autofocus
                trim
                placeholder="Instagram"
              />
            </b-form-group>

            <b-form-group
              class="required"
              label="Google Map"
              label-for="google_map"
            >
              <b-form-input
                id="google_map"
                v-model="storeData.google_map"
                autofocus
                trim
                placeholder="Google Map"
              />
            </b-form-group>

            <b-form-group class="required" label="Status" label-for="is_active">
              <b-form-checkbox
                v-model="storeData.is_active"
                checked="true"
                name="check-button"
                switch
                inline
                class="custom-control-success"
              >
                {{ (storeData.is_active)?'Active': 'Inactive' }}
              </b-form-checkbox>
            </b-form-group>

            <!-- Form Actions -->

            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ button_text }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </validation-observer>
    </template></b-sidebar
  >
</template>


<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BFormCheckbox,
  BOverlay,
  BFormDatepicker,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    vSelect,
    BOverlay,
    BFormDatepicker,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewStoreSidebarActive",
    event: "update:is-add-new-store-sidebar-active",
  },
  props: {
    isAddNewStoreSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      max,
    };
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const blankStoreData = {
      id: 0,
      name: "",
      address: "",
      phone: "",
      email: "",
      website: "",
      working_hour: "",
      facebook: "",
      ig_link: "",
      google_map: "",
      is_active: true,
    };
    const button_text = ref("Add");

    const storeData = ref(JSON.parse(JSON.stringify(blankStoreData)));

    const resetstoreData = () => {
      storeData.value = JSON.parse(JSON.stringify(blankStoreData));
    };

    const toast = useToast();

    watch(
      () => [props.id, props.isAddNewStoreSidebarActive],
      () => {
        if (props.id > 0 && props.isAddNewStoreSidebarActive) {
          /*
          storeData.value.id = props.data.id;
          storeData.value.name = props.data.name;
          storeData.value.address = props.data.address;
          storeData.value.phone = props.data.phone;
          storeData.value.email = props.data.email;
          storeData.value.website = props.data.website;
          */
          storeData.value = { ...props.data };
          storeData.value.is_active = props.data.is_active == 1 ? true : false;

          if (storeData.value.id > 0) {
            button_text.value = "Edit";
          } else {
            button_text.value = "Add";
          }
        } else {
          button_text.value = "Add";
        }
      }
    );

    const onSubmit = () => {
      loading.value = true;
      store
        .dispatch("setting-store/addStore", storeData.value)
        .then((response) => {
          loading.value = false;
          emit("update:is-add-new-store-sidebar-active", false);
          emit("refetch-data");
          toast({
            component: ToastificationContent,
            props: {
              title: "Success",
              text: response.data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          loading.value = false;
          toast({
            component: ToastificationContent,
            props: {
              title: "Fail",
              text: error.response.data.message,
              icon: "HeartIcon",
              variant: "danger",
            },
          });
        });
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetstoreData);

    return {
      storeData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      button_text,
      loading,
    };
  },
};
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
#add-new-store-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>